//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_echo_snapshot } from "./snapshot_pb.js";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
/**
 * Describes the file dxos/echo/feed.proto.
 */
export const file_dxos_echo_feed = /*@__PURE__*/ fileDesc("ChRkeG9zL2VjaG8vZmVlZC5wcm90bxIOZHhvcy5lY2hvLmZlZWQizAEKC0ZlZWRNZXNzYWdlEjcKCXRpbWVmcmFtZRgBIAEoCzIkLmR4b3MuZWNoby50aW1lZnJhbWUuVGltZWZyYW1lVmVjdG9yEjQKB3BheWxvYWQYAiABKAsyIy5keG9zLmVjaG8uZmVlZC5GZWVkTWVzc2FnZS5QYXlsb2FkGk4KB1BheWxvYWQSOAoKY3JlZGVudGlhbBgKIAEoCzIiLmR4b3MuZWNoby5mZWVkLkNyZWRlbnRpYWxzTWVzc2FnZUgAQgkKB3BheWxvYWQiSwoSQ3JlZGVudGlhbHNNZXNzYWdlEjUKCmNyZWRlbnRpYWwYASABKAsyIS5keG9zLmhhbG8uY3JlZGVudGlhbHMuQ3JlZGVudGlhbGIGcHJvdG8z", [file_google_protobuf_any, file_dxos_halo_credentials, file_dxos_echo_snapshot, file_dxos_echo_timeframe]);
/**
 * Describes the message dxos.echo.feed.FeedMessage.
 * Use `create(FeedMessageSchema)` to create a new message.
 */
export const FeedMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_feed, 0);
/**
 * Describes the message dxos.echo.feed.FeedMessage.Payload.
 * Use `create(FeedMessage_PayloadSchema)` to create a new message.
 */
export const FeedMessage_PayloadSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_feed, 0, 0);
/**
 * Describes the message dxos.echo.feed.CredentialsMessage.
 * Use `create(CredentialsMessageSchema)` to create a new message.
 */
export const CredentialsMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_feed, 1);
//# sourceMappingURL=feed_pb.js.map